import { useQuery } from '@apollo/client';

import useUserCountryRelatedInfo from '@skippay/core/hooks/useUserCountryRelatedInfo';

import { REFERRALS } from 'constants/routes';
import AccountReferrerStatsQuery from 'queries/AccountReferrerStatsQuery.graphql';
import { createAbsoluteHref } from 'utils/routeUtils';

function useMyReferralStats() {
	const accountReferrerStats = useQuery(AccountReferrerStatsQuery);
	const { selfCareUrl } = useUserCountryRelatedInfo();

	const referralUrl =
		accountReferrerStats.data &&
		createAbsoluteHref(
			`${REFERRALS}/${accountReferrerStats.data.accountReferrerStats.code}`,
			selfCareUrl
		);

	return { ...accountReferrerStats, referralUrl };
}

export default useMyReferralStats;
